import { render, staticRenderFns } from "./AffiliateProgram.vue?vue&type=template&id=252dab6f"
import script from "./AffiliateProgram.vue?vue&type=script&lang=js"
export * from "./AffiliateProgram.vue?vue&type=script&lang=js"
import style0 from "./AffiliateProgram.vue?vue&type=style&index=0&id=252dab6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports